import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { en, ru, uz } from './translations'
import getDomainLanguage from 'helpers/getDomainLanguage'

const resources = {
  en: { translation: en },
  ru: { translation: ru },
  uz: { translation: uz },
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getDomainLanguage(),
    keySeparator: false,
    nsSeparator: false,
    interpolation: {
      escapeValue: false
    }
  })

export default i18n
